import FlexChild from "layouts/flex/FlexChild";
import style from "./SalesTodayStatus.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import Inline from "layouts/container/Inline";
import CustomIcon from "components/icons/CustomIcon";
import Center from "layouts/wrapper/Center";
import clsx from "classnames";
import Dummy from "components/Dummy";
import { useContext, useEffect, useRef, useState } from "react";
import { adminRequester, requester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useNavigate } from "react-router-dom";
import {
  Chart,
  LineController,
  BarController,
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
} from "chart.js";

Chart.register(
  LineController,
  BarController,
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend
);

const views = [
  {
    label: "일별",
    value: "day",
    getDate: () => {
      const date = new Date();
      date.setDate(date.getDate() - 6);
      return [date, new Date()];
    },
    toString: (data) => {
      const date = new Date(data);
      return `${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate()
      ).padStart(2, "0")}`;
    },
  },
  {
    label: "주별",
    value: "week",
    getDate: () => {
      const date = new Date();
      date.setDate(date.getDate() - 7 * 4 - date.getDay());
      return [date, new Date()];
    },
    toString: (data) => {
      const date = new Date(data);
      return `${String(date.getMonth() + 1).padStart(2, "0")} ${String(
        Math.ceil((date.getDay() + date.getDate()) / 7)
      )}주`;
    },
  },
  {
    label: "월별",
    value: "month",
    getDate: () => {
      const date = new Date();
      date.setMonth(date.getMonth() - 3, 1);
      return [date, new Date()];
    },
    toString: (data) => {
      const date = new Date(data);
      return `${String(date.getFullYear()).padStart(4, "0")}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
    },
  },
];

function SalesStatistic() {
  // const formattedToday = `${year}년 ${month}월 ${date}일`;
  const [view, setView] = useState(views[0]);
  const [mounted, setMounted] = useState(false);

  // const { isMobile } = useContext(BrowserDetectContext);
  const isMobile = false;
  // 오늘 날짜를 'MM월 dd일' 형식으로 표시 (한국어로)
  const [data, setData] = useState();
  const [summary, setSummary] = useState({ pay: 0, refund: 0 });
  const [chartInstance, setChartInstance] = useState();
  const chartContainer = useRef(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted && view) {
      const [start_date, end_date] = view.getDate();

      adminRequester.getStatistic(
        {
          status: "orders",
          start_date: start_date || new Date(),
          end_date: end_date || new Date(),
          interval: view.value,
        },
        (result) => {
          const datas = result.data;
          setData(result.data);

          const now = datas[datas?.length - 1];
          if (datas?.length > 0)
            setSummary({
              pay:
                (typeof now?.total_amount === "string"
                  ? Number(now.total_amount)
                  : now.total_amount) || 0,
              refund:
                (typeof now?.total_refund === "string"
                  ? Number(now.total_refund)
                  : now.total_refund) || 0,
            });
        }
      );

      if (chartInstance) {
        chartInstance.destroy();
      }
    }
  }, [mounted, view]);
  useEffect(() => {
    if (data && chartContainer.current) {
      const labels = data.map((d) => view.toString(d.standard_start_date));
      const chartData = {
        labels: labels,
        datasets: [
          {
            label: "매출",
            data: data && data.map((d) => d?.total_amount),
            backgroundColor: "transparent",
            borderColor: "skyblue",
            tension: 0.1,
            fill: true,
            type: "line",
          },
        ],
      };
      const config = {
        type: "line", // This is irrelevant when the type is specified on the dataset
        data: chartData,
        options: {
          maintainAspectRatio: false,
          scales: {
            y: {
              type: "linear",
              ticks: {
                callback: function(value) {
                  value = Math.floor(Number(value) / 10000);
                  if (value < 0) return 0;
                  return value;
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false, // legend 표시 여부
              position: "bottom", // 'top'|'left'|'bottom'|'right'
              align: "center", // 'start'|'center'|'end'
              labels: {
                padding: 10,
                boxWidth: 13,
              },
            },
          },
        },
      };
      setChartInstance(new Chart(chartContainer.current, config));
    }
  }, [data]);
  const Content = (props) => {
    const { color, minus, title, amount } = props;
    return (
      <div className={clsx(style.contentArea, { [style.bgColor]: color })}>
        <HorizontalFlex>
          <FlexChild>
            <P size={15}>{title}</P>
          </FlexChild>
          <FlexChild justifyContent={"flex-end"}>
            {minus && <div className={style.minus}>-</div>}
            <Dummy width={10} />
            <Inline>
              <P size={20} weight={"bold"}>
                {amount.toLocaleString("ko")}
              </P>
              <P>원</P>
            </Inline>
          </FlexChild>
        </HorizontalFlex>
      </div>
    );
  };

  return (
    <div className={style.container}>
      <VerticalFlex height="100%">
        <FlexChild height="max-content">
          <div className={style.label}>
            <HorizontalFlex gap={20} justifyContent="flex-start">
              {views.map((v) => (
                <FlexChild width="max-content" key={v.label}>
                  <Center textAlign={"left"}>
                    <P
                      cursor
                      size={15}
                      hover={v.value !== view.value}
                      textDecoration={v.value === view.value && "underline"}
                      onClick={() => setView(v)}
                    >
                      {v.label} 매출현황
                    </P>
                  </Center>
                </FlexChild>
              ))}
            </HorizontalFlex>
          </div>
        </FlexChild>
        <FlexChild>
          <div className={style.contentWrap} style={{ height: "100%" }}>
            <HorizontalFlex height="100%">
              <VerticalFlex
                border={"1px solid black"}
                borderRadius={"5px"}
                padding={"20px 0"}
              >
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content title={"결제금액"} amount={summary.pay} />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content
                        minus
                        title={"환불금액"}
                        amount={summary.refund}
                      />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
                <FlexChild>
                  <VerticalFlex>
                    <FlexChild width={"90%"}>
                      <Content
                        color
                        title={"총매출"}
                        amount={summary.pay - summary.refund}
                      />
                    </FlexChild>
                    <FlexChild width={"90%"}>
                      <div className={style.line} />
                    </FlexChild>
                  </VerticalFlex>
                </FlexChild>
              </VerticalFlex>
              <FlexChild height="100%">
                <canvas ref={chartContainer} />
              </FlexChild>
            </HorizontalFlex>
          </div>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default SalesStatistic;
